import { AwsRum } from 'aws-rum-web';
import { RUM_BETA_CONFIG, RUM_GAMMA_CONFIG, RUM_PROD_CONFIG } from 'src/util/cloudwatchRum/rumConfig';
import { getStage } from 'src/util/config';

let awsRum: any;

export default function initRumClient() {
    if (getStage() === 'test') return;

    let rumConfig = getConfig();

    try {
        awsRum = new AwsRum(
            rumConfig.applicationId,
            rumConfig.applicationVersion,
            rumConfig.applicationRegion,
            rumConfig.config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }

    return awsRum;
}

const getConfig = () => {
    switch (getStage()) {
        case 'test':
            return RUM_BETA_CONFIG;
        case 'beta':
            return RUM_BETA_CONFIG;
        case 'gamma':
            return RUM_GAMMA_CONFIG;
        case 'prod':
            return RUM_PROD_CONFIG;
        default:
            return RUM_BETA_CONFIG;
    }
};
